import gql from "graphql-tag";

export const UPSERT_MAILINGLIST_MUTATION = gql`
  mutation UpsertMailingListMutation(
    $id: ID
    $create: MailingListCreateInput!
    $update: MailingListUpdateInput!
  ) {
    upsertMailingList(where: { id: $id }, create: $create, update: $update) {
      id
      description
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/UpsertMailingList/queries.ts